import { OperationsService } from "../../../../core/services/operations.service";
import { SearchResponse } from '../../../models/dto/search-response';
import { PraticaLight } from '../../../models/pratica/pratica-light';

declare var $: any;
declare var getPraticaMapSync: any;

export class RicercatoreFulltextPratiche {
  pratiche: PraticaLight[] = [];
  searchResponse: SearchResponse;
  emptyResult:boolean;
  constructor(protected operationService: OperationsService){}

  praticheTrovate(searchResponse: SearchResponse, reload: boolean = false) {
    this.emptyResult = false;
    if (searchResponse) {
      if (!reload) {
        this.pratiche = new Array<PraticaLight>();
      }
      if (searchResponse.pratiche.length > 0) {
        this.searchResponse = searchResponse;
        this.pratiche = this.pratiche.concat(searchResponse.pratiche);
      } else {
        this.emptyResult = true;
        this.pratiche = [];
      }
    } else {
      this.emptyResult = true;
      this.pratiche = new Array<PraticaLight>();
    }
  }

  correlaPratiche(praticheCorrelate, praticaNew) {
    let ids: string[] = [];
    for (let i = 0; i < praticheCorrelate.length; i++) {
      if (praticheCorrelate[i].selected) {
        ids.push(praticheCorrelate[i].id);
      }
    }
    const praticaMap = this.getPraticaFromMap(praticaNew.tipoPratica.id);
    const urlCorrelaPratiche = praticaMap.pathCorrela;
    if (ids.length === 0) {
      return;
    }
    this.operationService.correlaPratiche(urlCorrelaPratiche, praticaNew.id, ids).subscribe(response => {
      console.log(response);
    });
  }  

  salvePratichePrecedentiObs(pratichePrecedenti, praticaNew, praticaCopyInfo) {
    const request = [];
    pratichePrecedenti.forEach(el => {
      const isContropartiSelected = praticaCopyInfo ? praticaCopyInfo.id === el.id : false;
      const obj = {
          idPratica: el.id,
          isContropartiSelected
      };
      request.push(obj);
    });
    return this.operationService.pratichePrecedenti(praticaNew.id, request)
  }

  salvePratichePrecedenti(pratichePrecedenti, praticaNew, praticaCopyInfo) {    
    this.salvePratichePrecedentiObs(pratichePrecedenti, praticaNew, praticaCopyInfo).subscribe(response => {
      console.log(response);
    });
  }

  copiaInfoPratichePrecedenti(praticheCopyInfo, praticaNew) {
    console.log(praticheCopyInfo);
  }

  private getPraticaFromMap(idTipoPraticaMap: any) {
    // let nomePraticaFE = FrontEndMapping.tipiPratica[idTipoPraticaMap];
    let pratica = getPraticaMapSync(idTipoPraticaMap);
    return pratica;
  }

}
